import { Dom7 as $ } from "framework7/bundle";
import { api, ok } from "./api.js";
import { localizeStr } from "./i18n.js";

// Begriffserklaerung als Sheet von unten. Es gibt hoechstens ein Sheet; wer
// ein zweites oeffnet, schliesst damit das erste. Das aktuelle Sheet liegt
// als window.dynamicSheet, weil die Seiten-Komponenten es (noch) direkt
// setzen und lesen - das raeumt Etappe 2 auf.
let app = null;

export function installThesaurus(f7) {
    app = f7;
}

export function closeThesaurus() {
    if (typeof window.dynamicSheet === "object" && window.dynamicSheet) {
        window.dynamicSheet.close();
        window.dynamicSheet = null;
    }
}

export function openThesaurus(uid) {
    if (typeof window.dynamicSheet === "object" && window.dynamicSheet) {
        closeThesaurus();
        setTimeout(() => openSheet(uid), 400);
    } else {
        openSheet(uid);
    }
}

function openSheet(uid) {
    api.get("/frontend/helper/explain", { params: { id: uid } }).then(function (res) {
        const resData = res.data;
        if (!ok(resData)) return;

        const dynamicSheet = app.sheet.create({
            swipeToClose: true,
            content: `
              <div class="sheet-modal">
                <div class="toolbar">
                  <div class="toolbar-inner">
                    <div><b>${resData.data.thesaurus.title}</b></div>
                  </div>
                </div>
                <div class="sheet-modal-inner">
                  <div class="block">
                    ${resData.data.thesaurus.bodytext}
                    <a class="standard-button sheet-close">${localizeStr("thesaurus_close")}</a>
                  </div>
                </div>
              </div>`,
            on: {
                closed() {
                    if (window.dynamicSheet === dynamicSheet) window.dynamicSheet = null;
                }
            }
        });

        window.dynamicSheet = dynamicSheet;
        dynamicSheet.open();

        const sheetMargin = 60;
        const sheetHeight =
            $(".sheet-modal .toolbar").outerHeight() + $(".sheet-modal .sheet-modal-inner .block").outerHeight() + sheetMargin;
        $(".sheet-modal").css("height", sheetHeight + "px");
    });
}
